import React, { useState, useEffect } from 'react';
import Box from './Box';
import CountdownTimer from './CountdownTimer';
import PrizeBox from './PrizeBox';
import Button from './Button';
import { Modal } from 'antd';
import LotteryInfo from './LotteryInfo';
import ModalHeader from './ModalHeader';
import { InfoCircleFilled } from '@ant-design/icons';
import LotteryNum from './LotteryNum';
import WinnerCustInfo from './WinnerCustInfo';
import "./custom.css";
import axios from 'axios';
import { message, Spin } from 'antd';
import { useNavigate } from "react-router-dom";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const initialValue = { status: false, data: [] }

const DashBoardBodyVisa = ({ lottNum, lottDrawDate, isReward, showprev, innRewardData, isshowlottnum, link, isComfirm }) => {
  let txt = '2024 оны 07-р сарын 5-ны өдөр эхний тохирол явагдана.';
  let txt2 = '2024.06.01 - 2024.06.30';
  let txt3 = '2024.06.01 - 2024.06.30';
  const navigate = useNavigate('');
  const [isPrevModalOpen, setPrevIsModalOpen] = useState(false);
  const [isLottModalOpen, setIsLottModalOpen] = useState(false);
  const [isLottInfoModalOpen, setIsLottInfoModalOpen] = useState(false);
  const [isPrevLottInfoModalOpen, setIsPrevLottInfoModalOpen] = useState(false);
  const [winnerCustModalOpen, setWinnerCustModalOpen] = useState(false);
  const [winnerModalOpen, setWinnerModalOpen] = useState(false);
  const [showLottNum, setShowLottNum] = useState(false);
  const [showPrevResult, setShowPrevResult] = useState(false);
  const [lottNumList, setLottNumList] = useState(initialValue);
  const [prevLottNumList, setPrevLottNumList] = useState(initialValue);
  const [prevResultCust, setPrevResultCust] = useState(initialValue);
  const [checkWinnerSpin, setCheckWinnerSpin] = useState(false);
  const [rewardData, setRewardData] = useState({ status: 0, reward: '', matchnum: '', lnum: '' });
  const [notWinnerModalOpen, setNotWinnerModalOpen] = useState(false);
  const [isWinnerComfirm, setIsWinnerComfirm] = useState(isComfirm);
  const [mtxt, setMtxt] = useState("");
  const [month, setMonth] = useState("");

  const [prevResult, setPrevResult] = useState([]);
  const [total, setTotal] = useState(0);


  let drawTime = { date: '', date2: '', time: '', time2: '' }
  const nowDate = new Date();
  const draw9 = new Date('2024-07-05T18:00:00');
  const draw10 = new Date('2024-08-05T18:00:00');
  const draw11 = new Date('2024-09-05T18:00:00');
  const draw12 = new Date('2024-10-05T18:00:00');
  const draw13 = new Date('2024-11-05T18:00:00');
  const draw14 = new Date('2024-12-05T18:00:00');
  const draw15 = new Date('2025-01-05T18:00:00');

  if (nowDate < draw9) {
    drawTime = { date: '2024-07-05', date2: '2024.07.05', time: '18:00', time2: '18:00:00' }
    txt = '2024 оны 7-р сарын 5-ны өдөр тохирол явагдана.';
    txt2 = '2024.06.01 - 2024.06.30';
    txt3 = '2024.06.01 - 2024.06.30';
  } else if (nowDate < draw10) {
    drawTime = { date: '2024-08-05', date2: '2024.08.05', time: '18:00', time2: '18:00:00' }
    txt = '2024 оны 8-р сарын 5-ны өдөр тохирол явагдана.';
    txt2 = '2024.07.01 - 2024.07.31';
    txt3 = '2024.06.01 - 2024.06.30';
  } else if (nowDate < draw11) {
    drawTime = { date: '2024-09-05', date2: '2024.09.05', time: '18:00', time2: '18:00:00' }
    txt = '2024 оны 9-р сарын 5-ны өдөр тохирол явагдана.';
    txt2 = '2024.08.01 - 2024.08.31';
    txt3 = '2024.07.01 - 2024.07.31';
  } else if (nowDate < draw12) {
    drawTime = { date: '2024-10-05', date2: '2024.10.05', time: '18:00', time2: '18:00:00' }
    txt = '2024 оны 10-р сарын 5-ны өдөр тохирол явагдана.';
    txt2 = '2024.09.01 - 2024.09.30';
    txt3 = '2024.08.01 - 2024.08.31';
  } else if (nowDate < draw13) {
    drawTime = { date: '2024-11-05', date2: '2024.11.05', time: '18:00', time2: '18:00:00' }
    txt = '2024 оны 11-р сарын 5-ны өдөр тохирол явагдана.';
    txt2 = '2024.10.01 - 2024.10.31';
    txt3 = '2024.09.01 - 2024.09.29';
  } else if (nowDate < draw14) {
    drawTime = { date: '2024-12-05', date2: '2024.12.05', time: '18:00', time2: '18:00:00' }
    txt = '2024 оны 12-р сарын 5-ны өдөр тохирол явагдана.';
    txt2 = '2024.11.01 - 2024.11.30';
    txt3 = '2024.10.01 - 2024.10.31';
  } else if (nowDate < draw15) {
    drawTime = { date: '2025-01-05', date2: '2025.01.05', time: '18:00', time2: '18:00:00' }
    txt = '2025 оны 1-р сарын 5-ны өдөр тохирол явагдана.';
    txt2 = '2024.12.01 - 2024.12.31';
    txt3 = '2024.11.01 - 2024.11.30';
  } else {
    drawTime = { date: '2025-01-05', date2: '2025.01.05', time: '18:00', time2: '18:00:00' }
    txt = '2025 оны 1-р сарын 5-ны өдөр тохирол явагдана.';
    txt2 = '2024.12.01 - 2024.12.31';
    txt3 = '2024.11.01 - 2024.11.30';
  }

  useEffect(() => {
    if (isReward === 1) {
      setRewardData(prevState => ({
        ...prevState, status: 1, reward: innRewardData.reward, matchnum: innRewardData.matchnum, lnum: innRewardData.lnum
      }));
      setWinnerModalOpen(true);
    }

    if (isshowlottnum === 1) {
      setShowLottNum(true);
    }

    if (showprev == 1) {
      setShowPrevResult(true);
    } else {
      setShowPrevResult(false);
    }

  }, [isReward, isshowlottnum]);

  const fetchPrevinfo = async (items) => {
    try {
      const response = await axios.post(`${baseURL}/happypay/index.php?cmd=prevresult`, items, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      let res = response.data
      if (res.status === true) {
        if (res.data.status == true) {
          setPrevResult(res.data.data);
          setTotal(res.data.total);
          setMtxt(res.data.mtxt);
          setMonth(res.data.month);
        } else {
          setShowPrevResult(false);
        }
      } else {
        localStorage.removeItem("localData");
        navigate("/login");
        message.error(res.msg);
      }

    } catch (error) {
      message.error("Алдаа гарлаа.");
    }
  }

  const showPrevModal = () => {

    if (showPrevResult === true) {
      const items = JSON.parse(localStorage.getItem('localData'));
      if (items) {
        if (prevResult.length === 0) {
          fetchPrevinfo(items);
        }
      } else {
        message.error("Session дууссан байна.");
        navigate("/login");
      }

    }
    setPrevIsModalOpen(true);

  };

  const fetchPrevLottinfo = async (items) => {
    try {
      const response = await axios.post(`${baseURL}/happypay/index.php?cmd=prevlottinfo`, items, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      let res = response.data
      if (res.status === true) {
        if (res.data.status == true) {
          setPrevLottNumList({ status: true, data: res.data.data });
        } else {
          message.error(res.data.msg);
        }
      } else {
        localStorage.removeItem("localData");
        navigate("/login");
        message.error(res.msg);
      }

    } catch (error) {
      message.error("Алдаа гарлаа.");
    }
  }

  const showPrevLottInfoModal = () => {
    if (showPrevResult === true) {
      const items = JSON.parse(localStorage.getItem('localData'));
      if (items) {
        if (prevLottNumList.status === false) {
          fetchPrevLottinfo(items);
        }
      } else {
        message.error("Session дууссан байна.");
        navigate("/login");
      }

    }
    setIsPrevLottInfoModalOpen(true);
  };

  const prevhandleCancel = () => {
    setPrevIsModalOpen(false);
  };

  const fetchLottInfo = async (items) => {
    try {
      const response = await axios.post(`${baseURL}/happypay/index.php?cmd=lottinfo`, items, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      let res = response.data
      if (res.status === true) {
        if (res.data.status == true) {
          setLottNumList({ status: true, data: res.data.data });
        } else {
          message.error(res.data.msg);
        }
      } else {
        localStorage.removeItem("localData");
        navigate("/login");
        message.error(res.msg);
      }

    } catch (error) {
      message.error("Алдаа гарлаа.");
    }
  }

  const showLotterModal = () => {
    if (showLottNum === true) {
      const items = JSON.parse(localStorage.getItem('localData'));
      if (lottNumList.status === false) {
        fetchLottInfo(items);
      }
      setIsLottInfoModalOpen(true);
    } else {
      setIsLottModalOpen(true);
    }
  };

  const lotteryhandleCancel = () => {
    setIsLottModalOpen(false);
  };

  const lotteryInfohandleCancel = () => {
    setIsLottInfoModalOpen(false);
  };

  const lotteryPrevInfohandleCancel = () => {
    setIsPrevLottInfoModalOpen(false);
  };

  const winnerCusthandleCancel = () => {
    setWinnerCustModalOpen(false);
    setPrevResultCust({ status: false, data: [] });
  };

  const winnerModalCancel = () => {
    setWinnerModalOpen(false);
  };

  const showWinnerModal = () => {
    setWinnerModalOpen(true);
  };

  const notWinnerModalCancel = () => {
    setNotWinnerModalOpen(false);
  };

  const showNotWinnerModal = () => {
    setNotWinnerModalOpen(true);
  };

  const fetchWinnerCust = async (items, num) => {
    try {
      const response = await axios.post(`${baseURL}/happypay/index.php?cmd=winnercust&num=${num}`, items, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      let res = response.data
      if (res.status === true) {
        if (res.data.status == true) {
          setPrevResultCust({ status: true, data: res.data.data });
        } else {
          message.error(res.data.msg);
        }
      } else {
        localStorage.removeItem("localData");
        navigate("/login");
        message.error(res.msg);
      }

    } catch (error) {
      message.error("Алдаа гарлаа.");
    }
  }

  const showWinnerCustinfo = (num) => {
    if (showPrevResult === true) {
      const items = JSON.parse(localStorage.getItem('localData'));
      if (items) {
        if (prevResultCust.status === false) {
          fetchWinnerCust(items, num);
        }
      } else {
        message.error("Session дууссан байна.");
        navigate("/login");
      }

      setWinnerCustModalOpen(true);
    } else {
      message.error("Алдаа гарлаа.");
    }

  }

  const fetchWinnerComfirm = async (items) => {
    try {
      const response = await axios.post(`${baseURL}/happypay/index.php?cmd=winnercomfirm`, items, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      let res = response.data;
      if (res.status === true) {
        if (res.data.status == true) {
          setIsWinnerComfirm(res.data.data);
          message.success("Амжилттай баталгаажлаа");
        } else {
          message.error(res.data.msg);
        }
      } else {
        localStorage.removeItem("localData");
        navigate("/login");
        message.error(res.msg);
      }

    } catch (error) {
      message.error("Алдаа гарлаа.");
    }
  }

  const winnerComfirm = () => {
    if (isWinnerComfirm === 0) {
      const items = JSON.parse(localStorage.getItem('localData'));
      fetchWinnerComfirm(items);
    }
  }

  const fetchCheckWinner = async (items) => {
    try {
      const response = await axios.post(`${baseURL}/happypay/index.php?cmd=checkiswinner`, items, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      let res = response.data;
      if (res.status === true) {
        if (res.data.isreward == 1) {
          setRewardData(prevState => ({
            ...prevState, status: 1, reward: res.data.reward, matchnum: res.data.matchnum, lnum: res.data.lnum
          }));
          showWinnerModal();
        } else if (res.data.isreward == 2) {
          setRewardData(prevState => ({
            ...prevState, status: 2, reward: "", matchnum: "", lnum: ""
          }));
          message.info("Энэ сарын тохирол эхлээгүй байна.");
        } else {
          setRewardData(prevState => ({
            ...prevState, status: 3, reward: "", matchnum: "", lnum: ""
          }));
          showNotWinnerModal();
        }
      } else {
        localStorage.removeItem("localData");
        navigate("/login");
        message.error(res.msg);
      }

    } catch (error) {
      message.error("Алдаа гарлаа.");
    }

    setCheckWinnerSpin(false);
  }

  const checkIsWinner = () => {
    if (rewardData.status === 1) {
      showWinnerModal();
    } else if (rewardData.status === 2) {
      message.info("Энэ сарын тохирол эхлээгүй байна.");
    } else if (rewardData.status === 3) {
      showNotWinnerModal();
    } else {
      setCheckWinnerSpin(true);
      const items = JSON.parse(localStorage.getItem('localData'));
      fetchCheckWinner(items);
    }
  }

  return (
    <div style={{ height: "calc(100% - 128px)" }} className='w-full flex'>
      <div className='w-2/3 h-full flex flex-col justify-center items-center space-y-10 laptop:space-y-2 tablet:space-y-8 tablet:w-full mobile:space-y-8 mobile:w-full laptop:h-[600px]'>
        <div className='w-full h-full flex space-x-10 laptop:space-x-2 tablet:flex-col tablet:space-x-0 tablet:space-y-8 mobile:flex-col mobile:space-x-0 mobile:space-y-8'>
          <Box style="p-8 w-1/2 h-full bg-white  laptop:p-4 laptop:py-6 tablet:w-full tablet:h-[330px] tablet:px-24 mobile:w-full mobile:h-[330px] mobile:px-2"><CountdownTimer targetDate={drawTime.date !== '' ? (drawTime.date + " " + drawTime.time2) : ""} time={drawTime.date !== '' ? (drawTime.date2 + "-ны өдөр " + drawTime.time) : ""} size={"small"} /></Box>
          <Box style="p-8 w-1/2 h-full bg-white flex flex-col items-center justify-between  laptop:p-4 laptop:py-6 tablet:w-full tablet:h-[330px] tablet:px-24 mobile:w-full mobile:h-[330px] mobile:px-2">
            <div className='w-full flex flex-col items-center space-y-4'>
              <div className='w-full flex justify-between'>
                <PrizeBox prize={"20,000"} number={3} />
                <PrizeBox prize={"50,000"} number={4} />
              </div>
              <div className='w-full flex justify-between'>
                <PrizeBox prize={"100,000"} number={5} />
                <PrizeBox prize={"300,000"} number={6} />
              </div >
              <PrizeBox prize={"1,000,000"} number={7} />
            </div>
            <Button style='bg-[#0168D7] text-white text-sm font-semibold rounded-md w-[200px] h-10 shadow-lg hover:opacity-90 duration-150' name='Өмнөх тохирол' onclick={showPrevModal} />

            <Modal open={notWinnerModalOpen} onCancel={notWinnerModalCancel} footer={null} centered width={1000} bodyStyle={{ height: '500px', margin: 0, padding: 0 }}>
              <ModalHeader text={"Тохирол шалгах"} />
              <div className='w-full h-[430px] flex flex-col items-center justify-center text-center text-xl font-semibold text-[#0987F3] mobile:text-lg'>
                <p>Та урамшууллын эзэн болоогүй байна. <br />Бритто картаа идэвхтэй уншуулаад дараа сарын тохиролд оролцоорой.</p>
              </div>
            </Modal>

            {/* aztan bolson hariltsagchiin medeelel */}
            <Modal open={winnerCustModalOpen} onCancel={winnerCusthandleCancel} footer={null} centered width={1000} bodyStyle={{ height: '500px', margin: 0, padding: 0 }}>
              <ModalHeader text={"өмнөх тохирлын азтан"} />
              <div className='w-full h-[465px] flex flex-col items-center justify-start space-y-4 py-4 overflow-y-auto text-center text-xl font-semibold text-[#0987F3] px-16 mobile:px-2 mobile:h-[470px]'>
                {prevResultCust.status === true ? (<>
                  {prevResultCust.data.map((e, index) => {
                    return (
                      <WinnerCustInfo name={e.name} regno={e.reg} key={index} />
                    );
                  })}
                </>) : (<div className='h-full w-full flex justify-center items-center'><Spin /></div>)}
              </div>
            </Modal>
            {/* aztan bolson hariltsagchiin medeelel */}

            <Modal open={isPrevModalOpen} onCancel={prevhandleCancel} footer={null} centered width={1000} bodyStyle={{ height: '600px', margin: 0, padding: 0 }}>
              <ModalHeader text={"өмнөх тохирлын мэдээлэл"} />
              {showPrevResult === true ?
                (prevResult.length > 0 ? (<div className='w-full h-[590px] flex flex-col items-center justify-between py-4 mobile:h-[600px]'>
                  {prevResult.map((e, index) => {
                    let lnum1 = e.lnum.substr(e.lnum.length - e.level);
                    let dots = "";
                    for (let i = 0; i < (e.lnum.length - lnum1.length); i++) {
                      dots = dots + "*";
                    }
                    lnum1 = dots + lnum1;
                    return (
                      <LotteryInfo mtxt={mtxt} key={index} num={e.level} lnum={lnum1} prize={e.reward} cnum={e.cnt} onclick={() => showWinnerCustinfo(e.level)} />
                    );

                  })}
                  {showPrevResult === true && total !== 0 ? (
                    <div className='w-full h-fit flex flex-col justify-center items-center space-y-2 mobile:h-[140px]'>
                      <p className='w-full text-center text-lg text-[#0987F3] mobile:text-base mobile:w-full'>{month}-р сард нийт <span className='font-bold '>{total}</span> харилцагч урамшуулалд хамрагдлаа</p>
                      <Button style="bg-[#0168D7] text-white text-center text-sm font-semibold rounded-md w-fit px-8 h-10 shadow-lg hover:opacity-90 duration-150" name='Өмнөх сарын эрхийн дугаар' onclick={showPrevLottInfoModal} />
                      {checkWinnerSpin ? (<div className='w-full h-10 flex items-center justify-center'><Spin /></div>) : (<Button style="bg-[#0168D7] text-white text-center text-sm font-semibold rounded-md w-fit px-8 h-10 shadow-lg hover:opacity-90 duration-150" name='Тохирол шалгах' onclick={checkIsWinner} />)}
                    </div>) : ""}
                </div>) : (<div className='w-full h-[540px] flex items-center justify-center mobile:h-450px'><Spin /></div>)) : (<p className='h-[408px] flex justify-center items-center text-xl text-center font-semibold text-[#0987F3] mobile:text-base'>Тохирол эхлээгүй байна.</p>)}
            </Modal>

            {/* omnoh sariin sugalaanii dugaar */}
            <Modal open={isPrevLottInfoModalOpen} onCancel={lotteryPrevInfohandleCancel} footer={null} centered width={1000} bodyStyle={{ height: '500px', margin: 0, padding: 0 }}>
              <ModalHeader text={"миний урамшууллын эрхийн дугаар"} />
              <div className='w-full h-[465px] flex flex-col items-center justify-between text-center text-xl font-semibold text-[#0987F3] px-16 mobile:px-2 mobile:h-[470px]'>

                {prevLottNumList.status === true ? (prevLottNumList.data.length > 0 ? (<div className='w-full grid grid-cols-4 gap-4 overflow-auto pr-1 my-custom-scrollbar my-6 mobile:h-fit tablet:grid-cols-3 mobile:grid-cols-1'>
                  {prevLottNumList.data.map((lnum, index) => {
                    return (
                      <LotteryNum num={lnum} key={index} />
                    );
                  })}
                </div>) : (<div className='w-full h-full flex justify-center items-center text-xl font-semibold'><p>Танд сугалаа байхгүй байна.</p></div>)) : (<div className='h-full w-full flex justify-center items-center'><Spin /></div>)}
                <div className='w-full h-1/6 flex justify-between items-end mobile:flex-col mobile:h-fit mobile:space-y-3'>
                  <div className='flex flex-col text-start mobile:text-base mobile:text-center mobile:w-full'>
                    <p>Хамрах хугацаа:</p>
                    <p>{txt3}</p>
                  </div>
                  <div className='flex flex-col text-end mobile:text-base mobile:text-center mobile:w-full'>
                    <p>Таны нийт урамшууллын дугаар:</p>
                    <p>{prevLottNumList.data.length} ширхэг</p>
                  </div>
                </div>
              </div>
            </Modal>
            {/* omnoh sariin sugalaanii dugaar */}
          </Box>
        </div>
        <div className='w-full h-full flex space-x-10 laptop:space-x-2  tablet:flex-col tablet:space-x-0 tablet:space-y-8 mobile:flex-col mobile:space-x-0 mobile:space-y-8'>
          <Box style="p-10 w-1/2 h-full bg-white flex flex-col justify-between items-center  laptop:p-4 laptop:py-6 tablet:w-full tablet:h-[330px] mobile:w-full mobile:h-[330px] mobile:px-2">
            <p className='uppercase text-[#0987F3] font-semibold text-xl'>миний урамшууллын эрх</p>
            <div className='flex flex-col justify-center items-center text-[#0987F3]'><p className='font-bold text-7xl'>{lottNum}</p><p className='text-xl'>ширхэг</p></div>
            <Button style="bg-[#0168D7] text-white text-sm font-semibold rounded-md w-[200px] h-10 shadow-lg hover:opacity-90 duration-150" name='Эрхийн дугаар харах' onclick={showLotterModal} />
            <Modal open={isLottModalOpen} onCancel={lotteryhandleCancel} footer={null} centered width={1000} bodyStyle={{ height: '500px', margin: 0, padding: 0 }}>
              <ModalHeader text={"миний урамшууллын эрхийн дугаар"} />
              <div className='w-full h-[430px] flex flex-col items-center justify-center text-center text-xl font-semibold text-[#0987F3] space-y-5'>
                <div className='flex items-start space-x-3 mobile:text-lg'>
                  <p className='mobile:flex mobile:flex-col mobile:justify-center items-center'><InfoCircleFilled className='mt-1 mr-2' /> <span>Таны нууцыг хамгаалахын тулд тохирол болохоос 2 хоногийн өмнө <br /> урамшууллын эрхийн дугаар байршуулна.</span></p>
                </div>
                <p>{txt}</p>
              </div>
            </Modal>

            <Modal open={isLottInfoModalOpen} onCancel={lotteryInfohandleCancel} footer={null} centered width={1000} bodyStyle={{ height: '500px', margin: 0, padding: 0 }}>
              <ModalHeader text={"миний урамшууллын эрхийн дугаар"} />
              <div className='w-full h-[465px] flex flex-col items-center justify-between text-center text-xl font-semibold text-[#0987F3] px-16 mobile:px-2 mobile:h-[470px]'>

                {lottNumList.status === true ? (lottNumList.data.length > 0 ? (<div className='w-full grid grid-cols-4 gap-4 overflow-auto pr-1 my-custom-scrollbar my-6 mobile:h-fit tablet:grid-cols-3 mobile:grid-cols-1'>
                  {lottNumList.data.map((lnum, index) => {
                    return (
                      <LotteryNum num={lnum} key={index} />
                    );
                  })}
                </div>) : (<div className='w-full h-full flex justify-center items-center text-xl font-semibold'><p>Танд сугалаа байхгүй байна.</p></div>)) : (<div className='h-full w-full flex justify-center items-center'><Spin /></div>)}
                <div className='w-full h-1/6 flex justify-between items-end mobile:flex-col mobile:h-fit mobile:space-y-3'>
                  <div className='flex flex-col text-start mobile:text-base mobile:text-center mobile:w-full'>
                    <p>Хамрах хугацаа:</p>
                    <p>{txt2}</p>
                  </div>
                  <div className='flex flex-col text-end mobile:text-base mobile:text-center mobile:w-full'>
                    <p>Таны нийт урамшууллын дугаар:</p>
                    <p>{lottNum} ширхэг</p>
                  </div>
                </div>
              </div>
            </Modal>
            <Modal open={winnerModalOpen} onCancel={winnerModalCancel} footer={null} centered width={1000} header={null} bodyStyle={{ height: '500px', margin: -24, padding: 0 }}>
              <div className='w-full h-full relative'>
                <div className='z-50 w-full h-full absolute flex flex-col justify-center items-center  space-y-8'>
                  <div className='w-2/3 h-56 bg-white rounded-lg flex flex-col justify-between items-center relative text-[#0987F3] py-16 mobile:px-4'>
                    <img className='w-44 absolute -top-12 mobile:w-36 mobile:-top-10' src="/images/3star.png" />
                    <p className='text-xl font-semibold mobile:text-sm mobile:text-center'>Баяр хүргэе, та урамшууллын эзэн болсон байна.</p>
                    <p className='text-5xl font-bold mobile:text-3xl'>{rewardData.reward} ₮</p>
                  </div>
                  <p className='w-4/5 text-center text-white text-lg font-semibold mobile:text-sm'>{txt3}-ний тохиролоор  таны {rewardData.lnum} дугаартай гүйлгээний {rewardData.matchnum} орон таарсан тул {rewardData.reward} ₮-ний урамшууллын эзэн боллоо.</p>
                  <Button style={isWinnerComfirm == 0 ? "bg-[#0168D7] text-white text-sm font-semibold rounded-md w-[180px]  h-10 shadow-lg hover:opacity-90 duration-150" : "bg-gray-400 cursor-default text-white text-sm font-semibold rounded-md w-[180px] h-10 shadow-lg"} name={isWinnerComfirm === 0 ? 'Баталгажуулах' : 'Баталгаажсан'} onclick={winnerComfirm} />
                </div>
                <img className='top-0 left-0 absolute w-full h-full object-cover z-0 rounded-lg' src="/images/bg.png" />
              </div>
            </Modal>
          </Box>
          <Box style="p-10 w-1/2 h-full bg-white laptop:p-2 laptop:py-6 tablet:w-full tablet:h-[330px] tablet:px-24 mobile:w-full mobile:h-[330px] mobile:px-2">
            <p className='uppercase text-[#0987F3] font-semibold text-xl'>шууд тохирлын видео</p>
            {link !== '' ? (<iframe className='w-full h-full' src={"https://www.facebook.com/plugins/video.php?href=" + link} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>) : ''}
          </Box>
        </div>
      </div>

      <div className='w-1/3 pl-10 laptop:pl-2 tablet:hidden mobile:hidden laptop:h-[600px]'>
        <Box style="w-full h-full bg-white"><img className='object-cover w-full h-full rounded-lg' src="/images/dash_banner_3.png" /></Box>
      </div>
    </div>
  );
}

export default DashBoardBodyVisa;